import { useDispatch, useSelector } from "react-redux"
import useAuth from "hooks/useAuth"
import { useAuthorizationSimple } from "hooks/useAuthorizationStrict"
import { useLocalStorage } from "@mantine/hooks"
import LocalStorage from "constants/local-storage"

export const AUTH_CHANGE_CURRENT_DC = "AUTH_CHANGE_CURRENT_DC"

const INITIAL_STATE = {
  dc: null,
}

export default function authReducer(state = INITIAL_STATE, { type, payload }) {
  switch (type) {
    case AUTH_CHANGE_CURRENT_DC:
      return {
        ...state,
        dc: payload,
      }

    default:
      return state
  }
}

export function changeDc(payload) {
  return {
    type: AUTH_CHANGE_CURRENT_DC,
    payload,
  }
}

export function useCurrentDc() {
  const [, setDc] = useLocalStorage({ key: LocalStorage.CURRENT_DC })
  const dc = useSelector((state: any) => state.auth.dc)
  const dispatch = useDispatch()
  function handleChange(payload) {
    dispatch(changeDc(payload))
    setDc(payload?.id || null)
  }

  return [dc, handleChange]
}

export function useCurrentDcId() {
  return useSelector((state: any) => state.auth.dc?.id)
}

export function useAuthDcs() {
  const viewAllDcData = useAuthorizationSimple("vt_view_all_dc_data")
  const { distributionCentres } = useAuth()

  return viewAllDcData
    ? [
        {
          id: undefined,
          name: "All DCs",
        },
      ].concat(distributionCentres)
    : distributionCentres
}
